import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { MembershipWidget } from './MembershipWidget'

/**
 * <holdstyring-membership> Web Component
 *
 * Displays user's membership information including klippekort and subscriptions.
 *
 * Attributes:
 *   api-key: Required. Your Holdstyring API key.
 *   theme-primary: Optional. Primary color (hex).
 *
 * Example:
 *   <holdstyring-membership api-key="wk_live_xxx"></holdstyring-membership>
 */
class HoldstyringMembershipElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return MembershipWidget
  }
}

// Register the custom element
if (!customElements.get('holdstyring-membership')) {
  customElements.define('holdstyring-membership', HoldstyringMembershipElement)
}

export { HoldstyringMembershipElement }
